import posthog from 'posthog-js';

const recordEvent = (eventName, properties = {}) => {
    // Check if we're in the browser environment
    if (typeof window === 'undefined') {
        console.warn("PostHog capture called on server-side, skipping");
        return;
    }

    try {
        const userId = posthog.get_distinct_id();
        posthog.capture(eventName, { ...properties, userId });
    } catch (error) {
        console.error("Error in PostHog capture:", error);
    }
}

export default recordEvent;